"use client";

import { useRouter } from "next/navigation";
import { useAuth } from "@workos-inc/authkit-nextjs/components";
import { TradeBottomCtaView } from "@/components/trade/trade-bottom-cta-view";
import {
  buildInventoryCreateUrl,
  buildInventorySignUpUrl,
} from "@/lib/auth/inventory-create-flow";
import { navigateToDocument } from "@/lib/document-navigation";

interface TradeBottomCtaProps {
  intent: "sell" | "recycle";
  productSlug: string;
  pluralName: string;
}

export function TradeBottomCta({
  intent,
  productSlug,
  pluralName,
}: TradeBottomCtaProps) {
  const router = useRouter();
  const { user } = useAuth();

  const handleClick = () => {
    const flowOptions = { productSlug, intent };

    if (user) {
      router.push(buildInventoryCreateUrl(flowOptions));
      return;
    }

    navigateToDocument(buildInventorySignUpUrl(flowOptions));
  };

  return <TradeBottomCtaView intent={intent} pluralName={pluralName} onStart={handleClick} />;
}
